import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Main from "./Main";

import ReportScreen from "./screens/reportscreen";
import LoginScreen from "./screens/loginscreen";
import ChangePWScreen from "./screens/changepwscreen";
import LogoutScreen from "./screens/logoutscreen";
import AdminScreen from "./screens/adminscreen";
import Management from "./screens/management";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/changepw" element={<ChangePWScreen />} />
        <Route path="/" element={<Main />} />
        <Route path="/report" element={<ReportScreen />} />
        <Route path="/admin" element={<AdminScreen />} />
        <Route path="/logout" element={<LogoutScreen />} />
        <Route path="/manage" element={<Management />} />
      </Routes>
    </Router>
  );
}

export default App;
